import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark' | 'system';

/**
 * Compatibilidad temporal para stores persistidos previos. No exponer públicamente.
 */
const LEGACY_DEFAULT_NAV_POSITION = 'side';
/**
 * Compatibilidad temporal para stores persistidos previos. No exponer públicamente.
 */
const LEGACY_DEFAULT_BUTTON_SHAPE = 'default';


/**
 * Funcionalidad para almacenar la selección de tema light o dark en el navegador de cada usuario
 */
export const THEME_STORAGE_KEY = 'ui:themeMode';

const isThemeMode = (v: unknown): v is ThemeMode =>
  v === 'light' || v === 'dark' || v === 'system';

const readThemeFromStorage = (): ThemeMode => {
  try {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
      if (isThemeMode(stored)) return stored;
    }
  } catch { /* ignore */ }
  return 'system';
};


interface UIState {
  sidebarCollapsed: boolean;
  theme: ThemeMode;
}

const initialState: UIState = {
  sidebarCollapsed: false,
  theme: readThemeFromStorage(),
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setTheme(state, action: PayloadAction<ThemeMode>) {
      state.theme = action.payload;
      try {
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(THEME_STORAGE_KEY, action.payload);
        }
      } catch { /* ignore */ }
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, setTheme } = uiSlice.actions;
export const selectSidebar = (s: { ui: UIState }) => s?.ui?.sidebarCollapsed ?? false;
export const selectTheme = (s: { ui: UIState }) => s?.ui?.theme ?? 'system';
export default uiSlice.reducer;

// Mantener referencias a defaults legacy para potencial rollback.
void LEGACY_DEFAULT_NAV_POSITION;
void LEGACY_DEFAULT_BUTTON_SHAPE;
